/**
 * This file is for global helper functions.
 * ToDo: consider using ProvidePlugin for this: https://stackoverflow.com/questions/37656592/define-global-variable-with-webpack
 */

export function isSitefinityEditor() {
  return $("body").hasClass("sfPageEditor") || typeof sitefinity === "object";
}